module.exports = __webpack_public_path__ + "img/DESC_SORT.8086bed7.svg";